export function isSafeTenantUrl(value, { allowedHosts = [], allowLocalhost = process.env.NODE_ENV !== "production" } = {}) {
  if (typeof value !== "string" || !value.trim()) return false;
  try {
    const url = new URL(value.trim());
    const hostname = url.hostname.toLowerCase().replace(/\.$/, "");
    const local = allowLocalhost && (hostname === "localhost" || hostname === "127.0.0.1");
    if ((!local && url.protocol !== "https:") || (local && !["http:", "https:"].includes(url.protocol))) return false;
    if (url.username || url.password || url.port || url.search || url.hash || !hostname) return false;
    const allowed = new Set(allowedHosts.map(host => String(host).trim().toLowerCase().replace(/\.$/, "")));
    if (!local && (!hostname.includes(".") || (allowed.size > 0 && !allowed.has(hostname)))) return false;
    return true;
  } catch (_error) {
    return false;
  }
}

export function safeTenantBaseUrl(value, options = {}) {
  if (!isSafeTenantUrl(value, options)) return null;
  const url = new URL(value.trim());
  return `${url.origin}${url.pathname.replace(/\/+$/, "")}`;
}

export function safeTokenizeRedirect({ destination, expectedDestination, instance, args = "", token, next = null }) {
  const base = safeTenantBaseUrl(destination);
  const expected = safeTenantBaseUrl(expectedDestination);
  if (!base || !expected || base !== expected || !instance || !token) return null;
  const params = new URLSearchParams(args || "");
  params.set("i", instance);
  params.set("t", token);
  if (next) params.set("next", next);
  return `${base}/authentic/tokenize?${params.toString()}`;
}
